import "../styles/alterTournament.css";
import { useState } from "react";
import Add from "../components/AddTournament";
import Update from "../components/UpdateTournament";
import Delete from "../components/DeleteTournament"

const AlterTournament = () => {
    const [state,setState]=useState(null);

  return (
    <div className="alter-tournament-page">

        {state===null &&
        <div className="alter">
            <div className="alter-types"
                 onClick={()=>setState("Add")}    
            >
                <h1>Add Tournament</h1>
            </div>
            <div className="alter-types"
                 onClick={()=>setState("Update")}
            >
                <h1>Update Status</h1>
            </div>
            <div className="alter-types"
                 onClick={()=>setState("Delete")}
            >
                <h1>Delete Tournament</h1>
            </div>
        </div>
        }
        
        {state!==null && 
        <div className="back"
             onClick={()=>setState(null)}>
            <h3>← Back</h3>
        </div>
        }

        {state==="Add"    && <Add/>   }
        {state==="Update" && <Update/>}
        {state==="Delete" && <Delete/>}
        


    </div>
  );
};

export default AlterTournament;
